/**
 * Which drop this is.
 *
 * Stamped by hand when an archive is cut, and shown at the bottom of Settings.
 * Deliberately not a git hash: the commit that changes this file changes its own
 * hash, so the two can never agree. A date and a drop number always can.
 * It exists because a stale extracted zip once cost half a day of debugging:
 * the app looked right, behaved wrong, and nothing on screen said which build
 * was actually running. Now something does.
 */
export const BUILD = "2026-08-31 · drop 15";
